<template>
    <Editor
      api-key="i1jx4840k173k43ppts9j8n99resujrgz0hwy2lu4dyq28tw"
      style="min-height: 450px;"
      :value="content"
      @input="updateContent"
      :init="{
        plugins: 'lists link image table code help wordcount',
        menubar: 'file edit view insert format tools table help',
        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
        browser_spellcheck: true,
        contextmenu: false,
        auto_focus: true,
        branding: false,
        statusbar: true,
        resize: true,
      }"
    />
</template>
  
<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  components: {
    Editor,
  },
  props: {
    content: {
    },
  },
  methods: {
    updateContent(value) {
      this.$emit('update:content', value);
    }
  }
};
</script>